export interface IStackdriverConfig {
  key: string;
  projectId: string;
  service: string;
  version: string;
  disabled: boolean;
}
